import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { NotificationLevel } from '../../enums/notification-level.enum';
import { Notification } from '../../models/notifications/notification.model';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
    private subscription: Subscription;

    notificationLevel = NotificationLevel;
    notification: Notification;

    constructor(
        public notificationService: NotificationService) { }

    ngOnInit(): void {
        this.subscription = this.notificationService.notification$
            .subscribe(n => this.notification = n);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}